import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.js'
import './index.css'
import reportWebVitals from "./reportWebVitals";

ReactDOM.createRoot(document.getElementById('root')).render(<App/>)
reportWebVitals();
